import ConditionalRender from "components/ConditionalRender";

const MiniQ2PrevS = ({item, t}) => {
     return (
        <>
            <div className="preview-item">
                <div className="row">
                    <div className="col-6">
                        <label>{t("confdist")}</label>
                        <div className="preview-input">{t(`confdist.${item.values.confdist}`)}</div>
                    </div>
                    <div className="col-6">
                        <label>{t("saturation")}</label>
                        <div className="preview-input">{item.values.saturation}</div>
                    </div>
                    <div className="col-6">
                        <label>{t("hysteresis")}</label>
                        <div className="preview-input">{item.values.hysteresis}</div>
                    </div>
                </div>
            </div>
            <div className="preview-item">
                <table className="table" style={{fontSize: ".875em", textAlign: "center"}}>
                    <thead>
                    <tr>
                        <td></td>
                        <th>P0</th>
                        <th>P1</th>
                        <th>P2</th>
                        <th>P3</th>
                        <th>P4</th>
                        <th>P5</th>
                        <th>P6</th>
                        <th>P7</th>
                        <th>P8</th>
                        <th>P9</th>
                        <th>P10</th>
                        <th>P11</th>
                    </tr>
                    </thead>
                    <tbody>
                    <ConditionalRender condition={item.values.confdist === 0 || item.values.confdist === 2}>
                        <tr>
                            <td>{t("confdist.0")}</td>
                            <td>{item.values.p0_threshold_s}</td>
                            <td>{item.values.p1_threshold_s}</td>
                            <td>{item.values.p2_threshold_s}</td>
                            <td>{item.values.p3_threshold_s}</td>
                            <td>{item.values.p4_threshold_s}</td>
                            <td>{item.values.p5_threshold_s}</td>
                            <td>{item.values.p6_threshold_s}</td>
                            <td>{item.values.p7_threshold_s}</td>
                            <td>{item.values.p8_threshold_s}</td>
                            <td>{item.values.p9_threshold_s}</td>
                            <td>{item.values.p10_threshold_s}</td>
                            <td>{item.values.p11_threshold_s}</td>
                        </tr>

                    </ConditionalRender>
                    <ConditionalRender condition={item.values.confdist === 1 || item.values.confdist === 2}>
                        <tr>
                            <td>{t("confdist.1")}</td>
                            <td>{item.values.p0_threshold_l}</td>
                            <td>{item.values.p1_threshold_l}</td>
                            <td>{item.values.p2_threshold_l}</td>
                            <td>{item.values.p3_threshold_l}</td>
                            <td>{item.values.p4_threshold_l}</td>
                            <td>{item.values.p5_threshold_l}</td>
                            <td>{item.values.p6_threshold_l}</td>
                            <td>{item.values.p7_threshold_l}</td>
                            <td>{item.values.p8_threshold_l}</td>
                            <td>{item.values.p9_threshold_l}</td>
                            <td>{item.values.p10_threshold_l}</td>
                            <td>{item.values.p11_threshold_l}</td>
                        </tr>
                    </ConditionalRender>
                    </tbody>
                </table>
            </div>

        </>
    )
}
export default MiniQ2PrevS